import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var LyceeIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "16.5",
                fill: "white",
                stroke: "#FFDF00",
                "stroke-width": "3"
            }),
            /*#__PURE__*/ _jsx("mask", {
                id: "mask0_66_87",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "8",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ _jsx("rect", {
                    x: "7",
                    y: "8",
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                mask: "url(#mask0_66_87)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M14.5 24.5441C14.0833 24.5441 13.7292 24.3983 13.4375 24.1066C13.1458 23.815 13 23.4608 13 23.0441V11.4816C13 11.2733 13.0972 11.1275 13.2917 11.0441C13.4861 10.9608 13.6597 10.9955 13.8125 11.1483L15.9375 13.2733L15.125 14.0858L15.8333 14.7941L16.6458 13.9816L18.5208 15.8566L17.7083 16.6691L18.4167 17.3775L19.2292 16.565L21.1042 18.44L20.2917 19.2525L21 19.9608L21.8125 19.1483L23.7083 21.0441L22.8958 21.8566L23.6042 22.565L24.4167 21.7525L26.3958 23.7316C26.5486 23.8844 26.5833 24.058 26.5 24.2525C26.4167 24.4469 26.2708 24.5441 26.0625 24.5441H14.5ZM15 22.5441H22.375L15 15.1691V22.5441Z",
                    fill: "#FFDF00"
                })
            })
        ]
    }));
};
